module.exports = __webpack_public_path__ + "img/u31088.7e0f72b2.jpg";